document.addEventListener('DOMContentLoaded', () => {
const widget = document.querySelector('.Cstm_offer_btn');

if (!widget) return;

let isDragging = false;
let startX = 0;
let startY = 0;
let offsetX = 0;
let offsetY = 0;

let suppressClick = false;

const HOLD_TIME = 250;
let holdTimer = null;

/* =========================
DESKTOP - MOUSE
========================= */

widget.addEventListener('mousedown', (e) => {
    if (e.button !== 0) return;

    const rect = widget.getBoundingClientRect();

    startX = e.clientX;
    startY = e.clientY;

    offsetX = e.clientX - rect.left;
    offsetY = e.clientY - rect.top;

    isDragging = false;
    suppressClick = false;

    holdTimer = setTimeout(() => {
    isDragging = true;
    suppressClick = true;

    widget.style.left = `${rect.left}px`;
    widget.style.top = `${rect.top}px`;
    widget.style.right = 'auto';
    widget.style.bottom = 'auto';

    widget.classList.add('dragging');
    }, HOLD_TIME);

    e.preventDefault();
});

document.addEventListener('mousemove', (e) => {
    if (!isDragging) return;

    let left = e.clientX - offsetX;
    let top = e.clientY - offsetY;

    const maxLeft = window.innerWidth - widget.offsetWidth;
    const maxTop = window.innerHeight - widget.offsetHeight;

    left = Math.max(0, Math.min(left, maxLeft));
    top = Math.max(0, Math.min(top, maxTop));

    widget.style.left = `${left}px`;
    widget.style.top = `${top}px`;

    e.preventDefault();
});

document.addEventListener('mouseup', () => {
    clearTimeout(holdTimer);

    if (isDragging) {
    isDragging = false;
    widget.classList.remove('dragging');
    }
});

/* =========================
MOBILE - TOUCH
========================= */

widget.addEventListener(
    'touchstart',
    (e) => {
    const touch = e.touches[0];

    const rect = widget.getBoundingClientRect();

    startX = touch.clientX;
    startY = touch.clientY;

    offsetX = touch.clientX - rect.left;
    offsetY = touch.clientY - rect.top;

    isDragging = false;
    suppressClick = false;

    holdTimer = setTimeout(() => {
        isDragging = true;
        suppressClick = true;

        widget.style.left = `${rect.left}px`;
        widget.style.top = `${rect.top}px`;
        widget.style.right = 'auto';
        widget.style.bottom = 'auto';

        widget.classList.add('dragging');
    }, HOLD_TIME);
    },
    { passive: true }
);

document.addEventListener(
    'touchmove',
    (e) => {
    if (!isDragging) return;

    const touch = e.touches[0];

    let left = touch.clientX - offsetX;
    let top = touch.clientY - offsetY;

    const maxLeft = window.innerWidth - widget.offsetWidth;
    const maxTop = window.innerHeight - widget.offsetHeight;

    left = Math.max(0, Math.min(left, maxLeft));
    top = Math.max(0, Math.min(top, maxTop));

    widget.style.left = `${left}px`;
    widget.style.top = `${top}px`;

    e.preventDefault();
    },
    { passive: false }
);

document.addEventListener('touchend', () => {
    clearTimeout(holdTimer);

    if (isDragging) {
    isDragging = false;
    widget.classList.remove('dragging');
    }
});

/* =========================
PREVENT POPUP ONLY AFTER DRAG
========================= */

widget.addEventListener(
    'click',
    (e) => {
    if (suppressClick) {
        e.preventDefault();
        e.stopImmediatePropagation();

        suppressClick = false;
    }
    },
    true
);
});